export { default } from "./tabs-button";
